import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import LernweltenPage from "./pages/LernweltenPage";
import WorldDetail from "./pages/WorldDetail";
import UeberPage from "./pages/UeberPage";
import FaqPage from "./pages/FaqPage";
import KontaktPage from "./pages/KontaktPage";
import LegalPage from "./pages/LegalPage";
import ConfirmPage from "./pages/ConfirmPage";
import SuccessPage from "./pages/SuccessPage";
import CancelPage from "./pages/CancelPage";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.12, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lernwelten" element={<LernweltenPage />} />
          <Route path="/lernwelten/:slug" element={<WorldDetail />} />
          <Route path="/ueber-visualma" element={<UeberPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/impressum" element={<LegalPage page="impressum" />} />
          <Route path="/datenschutz" element={<LegalPage page="datenschutz" />} />
          <Route path="/agb" element={<LegalPage page="nutzungsbedingungen" />} />
          <Route path="/nutzungsbedingungen" element={<LegalPage page="nutzungsbedingungen" />} />
          <Route path="/widerruf" element={<LegalPage page="widerruf" />} />
          <Route path="/bestaetigung" element={<ConfirmPage />} />
          <Route path="/kauf/erfolg" element={<SuccessPage />} />
          <Route path="/kauf/abbruch" element={<CancelPage />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
